import React from 'react';
import classNames from 'classnames';
import CongratulationsImage from '../../Assets/congratulations.png';

const Congratulations = ({ isFeedback }) => {
  const classes = classNames('manager-congratulations', {
    feedback: isFeedback,
  });
  return (
    <div className={classes}>
      <img src={CongratulationsImage} alt="congratulations" />
      <div>
        <div className="heading">Congratulations!</div>
        <div className="description">Thanks for completing the survey.</div>
      </div>
    </div>
  );
};

export default Congratulations;
